import { dscvrIcApi } from '@/shared/api';

export const useAcceptFrameTransactionMutation = (
  frameUrl: string,
  transactionId: string,
) => {
  return dscvrIcApi.frame.acceptFrameTransaction(frameUrl, transactionId);
};
